var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('div',{staticClass:"liveStayus-item-twitter"},[_c('a',{attrs:{"href":_vm.createSnsUrl(),"target":"_blank"}},[_c('img',{attrs:{"src":"/img/kakusan.png"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }